export default "__VITE_ASSET__7RtIgrSPgYTsQ5WGpNokyA__"